import DataService from "domain/data/dataService";

export const getServerSideProps = async () => {
  const DEFAULT_CASE_TYPE = "I-765";

  const service = new DataService();
  const dataListServiceCenter = await service.getListMetaServiceCenter(
    DEFAULT_CASE_TYPE,
  );

  const dataListFiscalYear = await service.getListMetaFiscalYear(
    DEFAULT_CASE_TYPE,
  );

  return {
    redirect: {
      destination: `/data/trends/${DEFAULT_CASE_TYPE}/${
        dataListServiceCenter.list[0].code
      }/${
        dataListFiscalYear.list.sort(
          // sort in order of year, descending
          (first, second) => Number(second.code) - Number(first.code),
        )[0].code
      }/`,
      permanent: false,
    },
  };
};

export default () => null;
